import { React } from 'react';
import Box from '@mui/material/Box';
import PrimeiraAvaliacao from './primeiraAvaliacao';
import { useParams } from "react-router-dom";
import { RootLayout } from '../../layout';
import CssBaseline from '@mui/material/CssBaseline';

export default function MiniDrawer() {
  const { id } = useParams();
  return (
    <Box>
      <CssBaseline />

      <RootLayout>
        <PrimeiraAvaliacao idPaciente={id} />
      </RootLayout>
    </Box >
  );
}